import {CampaignForm} from 'common/pages/campaign/CampaignForm'

export const CampaignAdvForm = (props) =>
    <CampaignForm {...props} mode={props.mode} />